import { Component, HostListener, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { IPushNotify } from '@sv/interfaces';

@Component({
  selector: 'app-popup-notifications-dialog',
  templateUrl: './popup-notifications-dialog.component.html',
  styleUrls: ['./popup-notifications-dialog.component.scss']
})
export class PopupNotificationsDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: IPushNotify,
    private dialogRef: MatDialogRef<PopupNotificationsDialogComponent>,
    private router: Router
  ) {}

   // Watch for clicks in entire component
   @HostListener('click', ['$event'])
   // enables us the set routerlinks in push notifications with e.g. <a href="./workshop">Workshop</a>
   onClick(event: MouseEvent) {
     // If we don't have an anchor tag, we don't need to do anything.
     if (event.target instanceof HTMLAnchorElement === false) {
       return;
     }
     // Prevent page from reloading
     event.preventDefault();
     const target = event.target as HTMLAnchorElement;
     if (window.location.href.startsWith(target.origin)) {
       this.router.navigate([target.pathname]); // Navigate to the path in the link
     } else {
       window.open(target.href); // open external link in new tab
     }
   }

  close() {
    this.dialogRef.close();
  }
}
